module.exports = __webpack_public_path__ + "static/media/ASHOKLEY_F1.06f7b427.txt";